<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">patient_list</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('association.Associations') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                            <div class="text-right col-lg-6 d-flex flex-column justify-content-center">
                                <router-link to="/association/create" class="mt-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0" :title="$t('association.New_association')">
                                    {{ $t('association.New_association') }}
                                </router-link>
                            </div>
                        </div>                        
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3" ref="tableWrapper">
                        <table id="association-list" class="table table-flush" ref="associationTable" :key="associationKey">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('association.Name') }}</p></th>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Address') }}</p></th>                                    
                                    <th></th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="association in associations" v-bind:key="association.id">   
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="avatar avatar-lg me-3">                                                
                                                <img :src="association.isLogoLoading ? loadingImageUrl : association.logoImageUrl" :alt="$t('association.Logo_image')" class="shadow-sm" />
                                            </div>                                    
                                            <div class="text-left">
                                                <h6 class="mb-0 text-sm font-weight-normal">
                                                    {{ association.name }}
                                                </h6>
                                                <p class="text-xs text-secondary mb-0">{{ $t('association.Chamber_of_commerce_no') }}: {{ association.chamberOfCommerceNo }}</p>
                                            </div>
                                        </div>                                        
                                    </td>                                    
                                    <td class="text-sm font-weight-normal" v-html="association.associationFullAddress"></td>      
                                    <td>
                                        <div class="float-end">                                                                                        
                                            <button :data-id="association.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 preview-button" style="margin-right: 10px !important;" :title="$t('common.Details')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">preview</i>
                                            </button>
                                            <button :data-id="association.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                            </button>
                                            <button :data-id="association.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')" :disabled="!association.canDelete">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                            </button>
                                        </div>                                        
                                    </td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios'
import loadingImageUrl from "@/assets/img/LoadingImage.gif";
import { DataTable } from "simple-datatables";

export default {
    name: 'Association_index_page',
    components: {
    },
    data() {
        return {
            associations: [],
            gets: [],
            dataTableInstance: null,
            isLoading: true,
            loadingImageUrl,
            associationListClickBound: false,
            associationKey: 0
        }
    },
    async mounted() {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get("association/getall");
            this.gets = response.data;
            
            if (this.gets.success) {
                if(this.gets.data != null) {

                    this.associations = this.gets.data.associationList.map(a => ({
                        ...a,
                        logoImageUrl: null,
                        isLogoLoading: false
                    }));

                    for (let association of this.associations) {     
                        association.logoImageUrl = await this.fetchLogoImage(association);
                    }

                    await this.$nextTick();
                    await new Promise(requestAnimationFrame);

                    this.initAssociationDataTable();
                }
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: {
        async initAssociationDataTable() {
            if (this.dataTableInstance) {
                try { this.dataTableInstance.destroy(); } catch { console.log('Error destroying datatable') }
                this.dataTableInstance = null;
                this.associationKey++;
                await this.$nextTick();
                await new Promise(requestAnimationFrame);
            }

            const tableEl = this.$refs.associationTable; // now the TABLE, not the THEAD
            if (!tableEl || tableEl.tagName !== 'TABLE') return;
            if (!tableEl.tBodies || tableEl.tBodies.length === 0) {
                await this.$nextTick();
                await new Promise(requestAnimationFrame);
                if (!tableEl.tBodies || tableEl.tBodies.length === 0) return;
            }

            this.dataTableInstance = new DataTable(tableEl, {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: false },
                    { select: 2, sortable: false }
                ],
                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                }
            });

            if (!this.associationListClickBound) {                
                this.$refs.tableWrapper.addEventListener('click', (event) => {                    
                    const targetElement = event.target.closest('[data-id]');
                    if (!targetElement) return;

                    const id = targetElement.getAttribute('data-id');
                    if (!id) return;

                    if (event.target.closest('.edit-button')) {
                        this.$router.push({ name: 'Edit Association', params: { id } });
                    } else if (event.target.closest('.preview-button')) {
                        this.$router.push({ name: 'Preview Association', params: { id } });
                    } else if (event.target.classList.contains('delete-button')) {
                        this.deleteAssociation(id);
                    }
                });           
                this.associationListClickBound = true;
            }
        },
        async fetchLogoImage(association) {
            try {
                this.isLoading = true;

                const response = await axios.get(`/association/getassociationlogo`, {
                    params: { associationId: association.id },
                    responseType: 'blob'
                });

                // Check if the response is actually an image
                const contentType = response.headers['content-type'];
                if (!contentType.startsWith('image/')) {
                    // The blob contains an error, not an image
                    return require('@/assets/no-image.png');
                }

                const imageUrl = URL.createObjectURL(response.data);
                return imageUrl;
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.warn('Image not found for association:', association.id);
                } else {
                    console.error('Error fetching logo image:', error);
                }
                return require('@/assets/no-image.png'); // fallback image
            } finally {  
                this.isLoading = false;
            }
        },
        async deleteAssociation(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {
                        // Put delete logic
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("association/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                const response = await axios.get("association/getall");
                                this.gets = response.data;

                                if (this.gets.success) {
                                    this.associations = this.gets.data.associationList.map(a => ({
                                        ...a,
                                        logoImageUrl: null,
                                        isLogoLoading: false
                                    }));

                                    this.associationKey++;

                                    // Destroy the existing instance
                                    if (this.dataTableInstance) {
                                        this.dataTableInstance.destroy();
                                        this.dataTableInstance = null;
                                    }

                                    for (let association of this.associations) {     
                                        association.logoImageUrl = await this.fetchLogoImage(association);
                                    }

                                    await this.$nextTick();
                                    await new Promise(requestAnimationFrame);

                                    this.initAssociationDataTable();
                                    
                                    this.$showSuccess('errors.Success_record_is_deleted_successfully');                                    
                                } else {
                                    this.$showError('errors.Contact_system_admin');
                                }
                            } else {
                                this.$showError('errors.Contact_system_admin');
                            }
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        }
                        
                        this.$store.commit('setShowLoading', false);
                    }
                });            
        }
    }
}
</script>
<style scoped>
    ::v-deep(.table tbody tr:hover) {
        background-color: #f0f2f5 !important;;
        color: #333 !important;;
        transition: background-color 0.2s ease-in-out !important;;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .font-size-14 {
        font-size: 14px !important;
    }
</style>